<div class="menu-drawer__root">
    <div
        #boundaryElement
        class="menu-drawer__content-root"
        [class.right]="direction === 'right'"
        [class.left]="direction === 'left'"
        [class.padded]="padded"
        [class.full-width]="fullwidth"
        [@slideContent]="{value: animationState, params: {translateSign, boxShadow}}"
        (@slideContent.start)="onAnimationEvent($event)"
        (@slideContent.done)="onAnimationEvent($event)"
        (mouseleave)="onClose()"
        (mouseenter)="onMouseEnter()"
    >
        <ng-content></ng-content>
    </div>
    <div
        *ngIf="backdrop"
        class="menu-drawer__backdrop"
        [class.clickable]="backdropClickable"
        [@opacity]="animationState"
        (@opacity.start)="onOpacityAnimation($event)"
        (@opacity.done)="onOpacityAnimation($event)"
    ></div>
</div>
